import { v4 as uuidv4 } from 'uuid';

export const name = 'templatesService';
export default function templatesService($http, $q, $log, analyticsFactory, pusherTaskMessageDispatcher, imageLoadProgressService,
                                         additionalErrorsTranslatorFactory, $window, $timeout, $translate, $mdDialog) {
    //noinspection BadExpressionStatementJS
    'ngInject';

    let composerBaseUrl = "/api/composer-service/v1/composer/templates";
    let composerDataUrl = "/api/composer-service/v1/composer/data";
    let pdfBaseUrl='/api/composer-service/v1/composer/pdfs';
    let portalUrl = "/api/portal/v1";
    //var storageServiceBaseUrl = "/api/storage_service/v1/assets";

    let errorImage = require('./images/Error.jpg');
    let uploadingImage = require('./images/Uploading.jpg');
    let processingImage = require('./images/Processing.jpg');

    let pusherEventsForTasks = ['COMPOSER_THUMBNAIL_REQUEST_ENDED','COMPOSER_IMPOSED_THUMBNAIL_REQUEST_ENDED'];

    let pusherTaskMessageDispatcherObj = pusherTaskMessageDispatcher.createPusherTaskMessageDispatcher();

    return {
        deleteTemplate:deleteTemplate,
        deleteMultipleTemplates:deleteMultipleTemplates,
        getAllTemplates:getAllTemplates,
        getTemplatesByPage:getTemplatesByPage,
        uploadTemplate:uploadTemplate,
        getTemplate:getTemplate,
        getUserPreferences:getUserPreferences,
        getTemplateDb:getTemplateDb,
        getTemplateDbFromURL:getTemplateDbFromURL,
        uploadFile:uploadFile,
        createEmptyFileEntryHelper:createEmptyFileEntryHelper,
        //fetchCache:fetchCache,
        fetchCacheWithEmbeddedDataRequest:fetchCacheWithEmbeddedDataRequest,
        updateTags:updateTags,
        composePdf:composePdf,
        producePdfOutputName:producePdfOutputName,
        updateTemplate:updateTemplate,
        uploadData:uploadData,
        fetchImposedSpread:fetchImposedSpread,
        //getChannelName:getChannelName,
        addDisplayStatusToTemplate:addDisplayStatusToTemplate,
        downloadDataToBlob:downloadDataToBlob,
        updatePredefinedTemplates:updatePredefinedTemplates,
        uploadFileToStorageService:uploadFileToStorageService,
        viewErrorDetails:viewErrorDetails,
        jobPropertiesRequest:jobPropertiesRequest,
        updateJobProperties:updateJobProperties,
        getNumberOfAllowedParallelThreads:getNumberOfAllowedParallelThreads,
        updateNumberOfAllowedParallelThreads:updateNumberOfAllowedParallelThreads,
        getConfigurations:getConfigurations
    };


    //////////////////////
    ///////////////////////

    function downloadDataToBlob(storageId, mimeType, onload){
        let url = composerDataUrl + '/' + storageId + '/presigned-url';

        $http({method: 'GET', url: url, headers: {'Accept':'application/json'}})
          .then(function(response) {
            var oReq = new XMLHttpRequest();

            let url = response.data.presignedUrl;
            oReq.open("GET", url, true);
            oReq.responseType = "arraybuffer";
            oReq.onload = function(oEvent) {
                let blob = new Blob([this.response], {type:mimeType});
                onload(blob);
            };

            oReq.send();
        },function(error){
            onload(null);
        });
    }

    function producePdfOutputName(templateName, dataFileName){
        let outputPdfName = null;
        if(templateName !== undefined && templateName !== null){
            if(dataFileName !== undefined && dataFileName !== null && dataFileName !== 'null'){
                outputPdfName = templateName + "_" + dataFileName + ".pdf";
            }else{
                outputPdfName = templateName + ".pdf";
            }
        }

        return outputPdfName;
    }

    function fetchImposedSpread(templateId, imposedSpreadRequest, templateName = null, dataFileName = null, assetsLibrariesStorageIds = null, fullSizeImage = false){

        let functionName = 'templatesService.fetchImposedSpread';
        $log.log(angular.toJson({functionName:functionName, action:'function called', imposedSpreadRequest:imposedSpreadRequest}));
        let defer = $q.defer();

        pusherTaskMessageDispatcherObj.registerProcessingPusherEventIfNotRegistered(pusherEventsForTasks).then(
            function(success){
                let url = composerBaseUrl + '/' + templateId + '/imposedthumbnails';

                imposedSpreadRequest.spreadNumber = imposedSpreadRequest.cacheCellRequests[0].recordData[0];

                let availableSpaceForImage = {deviceScreenWidth:null, deviceScreenHeight:null};
                if(!fullSizeImage){
                    availableSpaceForImage = imageLoadProgressService.getAvailableSpaceForImage();
                }

                let clientTimestampInMilliseconds = (new Date()).getTime() - (new Date()).getTimezoneOffset()*60*1000;

                let requestFromServer={
                    spreadNumber: imposedSpreadRequest.cacheCellRequests[0].recordData[0],//cacheCellRequests[0].recordData[0],
                    dataStorageId: imposedSpreadRequest.dataStorageId,
                    fetchMetadataInfo:imposedSpreadRequest.fetchMetadataInfo,
                    deviceScreenHeight:availableSpaceForImage.deviceScreenHeight,
                    deviceScreenWidth:availableSpaceForImage.deviceScreenWidth,
                    ClientTimestampInMilliseconds:clientTimestampInMilliseconds,
                    outputPdfName: producePdfOutputName(templateName, dataFileName),
                    assetsLibsStorageIds: assetsLibrariesStorageIds
                };

                $http({method: 'POST', data:requestFromServer, url: url, headers: {'Accept':'application/json','Content-Type':'application/json'}}).
                    then(function(thumbnailRequestProcess){
                        pusherTaskMessageDispatcherObj.registerTaskHandlerMethod(
                            thumbnailRequestProcess.data.processId,
                            function(cellImageUrlsResult){
                                if(cellImageUrlsResult.status === 'Success'){
                                    $log.log(angular.toJson({functionName:functionName, action:'checkImposedSpreadRequestStatus completed successfully', cellImageUrlsResult:cellImageUrlsResult}));

                                    // convert result cell to 0 based
                                    for(let iCell=0; iCell < cellImageUrlsResult.cellWithImageStorageId.length; iCell++){
                                        cellImageUrlsResult.cellWithImageStorageId[iCell].cell.record = imposedSpreadRequest.cacheCellRequests[0].record ;
                                        cellImageUrlsResult.cellWithImageStorageId[iCell].cell.page = imposedSpreadRequest.cacheCellRequests[0].page;
                                    }

                                    cellImageUrlsResult.imposedSpreadRequest = imposedSpreadRequest;
                                    defer.resolve(cellImageUrlsResult);

                                }else if(cellImageUrlsResult.status === 'Error'){
                                    $log.error(angular.toJson({functionName:functionName, action:'checkImposedSpreadRequestStatus process ended with error', cellImageUrlsResult:cellImageUrlsResult}));

                                    let engineError = null;
                                    if(cellImageUrlsResult.engineErrorMessage){
                                        engineError={
                                            smsError:{
                                                statusCode:500,
                                                subCode:-1,
                                                message:cellImageUrlsResult.engineErrorMessage
                                            }
                                        };
                                    }else{
                                        engineError= {
                                            smsError: {
                                                message: "Unknown",
                                                statusCode: 500
                                            }
                                        };
                                    }
                                    cellImageUrlsResult.engineError = engineError;

                                    defer.reject(cellImageUrlsResult);
                                }
                            });
                    },function(error){
                        $log.error(angular.toJson({functionName:functionName, action:'return with error', templateId:templateId, error:error.data, status:error.status}));
                        defer.reject(error.status);
                    }
                );
            },
            function(status){
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            }
        );

        return defer.promise;
    }

    function checkImposedSpreadRequestStatus(templateId, processId){
        let functionName = 'templatesService.checkImposedSpreadRequestStatus';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called', templateId:templateId, processId:processId}));

        let defer = $q.defer();

        let url = composerBaseUrl + '/' + templateId + '/' + "imposedthumbnails" + '/' + processId;

        $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
            then(function(cellImageUrlsResult) {
                $log.info(angular.toJson({functionName: functionName, action: 'successfully return', cellImageUrlsResult:cellImageUrlsResult}));
                defer.resolve(cellImageUrlsResult.data);
            },function (error) {
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            });


        return defer.promise;
    }

    function getNumberOfAllowedParallelThreads(){
        let functionName = 'templatesService.getNumberOfAllowedParallelThreads';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called'}));

        let defer = $q.defer();

        let url = composerBaseUrl + '/parallel-threads';

        $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
            then(function(response) {
                $log.info(angular.toJson({functionName: functionName, action: 'successfully return', response:response}));
                defer.resolve(response.data);
            },function (error) {
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            });


        return defer.promise;
    }

    function updateNumberOfAllowedParallelThreads(numOfFastParallelThreads, numOfRichParallelThreads, numOfFastParallelThreadsSdk, numOfRichParallelThreadsSdk){
        let functionName = 'templatesService.updateNumberOfAllowedParallelThreads';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called'}));

        let defer = $q.defer();

        let url = composerBaseUrl + '/parallel-threads';

        let data = {
          "numberOfAllowedFastParallelThreads": numOfFastParallelThreads,
          "numberOfAllowedRichParallelThreads": numOfRichParallelThreads,
          "numberOfAllowedFastParallelThreadsSdk": numOfFastParallelThreadsSdk,
          "numberOfAllowedRichParallelThreadsSdk": numOfRichParallelThreadsSdk
        };


        $http({method: 'POST', url: url, data, headers: {'Accept':'application/json','Content-Type':'application/json'}}).
            then(function(response) {
                $log.info(angular.toJson({functionName: functionName, action: 'successfully return', response:response}));
                defer.resolve(response.data);
            },function (error) {
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            });

        return defer.promise;
    }

    function uploadData(data){
        let functionName = 'templatesService.uploadData';
        $log.log(angular.toJson({functionName:functionName, action:'function called', data:data}));
        let defer = $q.defer();


        $http({method: 'POST', data:data, url: composerDataUrl, headers: {'Accept':'application/json','Content-Type':'application/json'}}).
            then(function(storageAssetInfo){
                $log.log(angular.toJson({functionName:functionName, action:'return successfully', storageAssetInfo:storageAssetInfo}));
                defer.resolve(storageAssetInfo.data.assetId);
            },function(error){
                $log.error(angular.toJson({functionName:functionName, action:'return with error', error:error.data, status:error.status}));
                defer.reject(error.status);
            });
        return defer.promise;
    }


    function composePdf(templateId, composePdfRequests){//, templateName = null, dataFileName = null
        let functionName = 'templatesService.composePdf';
        $log.log(angular.toJson({functionName:functionName, action:'function called', templateId:templateId, composePdfRequests:composePdfRequests}));

        var defer = $q.defer();
        var url = pdfBaseUrl + "/" + templateId + "/pdf";
        //let data = angular.copy(composePdfRequests);
        const data = {"pdfRequestList":composePdfRequests};

            //data.vdpDatas = [];
            //data.vdpDatas.push(vdpData);
            //data.vdpDatas.push(vdpData);


            // data.clientTimestampInMilliseconds = (new Date()).getTime() - (new Date()).getTimezoneOffset() * 60 * 1000;
            // data.outputPdfName = producePdfOutputName(templateName, dataFileName);

        $http({method: 'POST', data:data, url: url, headers: {'Content-Type':'application/json'}}).
        then(function(){
            $log.log(angular.toJson({functionName:functionName, action:'return successfully', templateId:templateId}));

           let totalTime = null;

            analyticsFactory.eventTrack(analyticsFactory.actions.createPDF, analyticsFactory.categories.composer, analyticsFactory.labels.success, totalTime);
            defer.resolve();
        },function(error){
            $log.error(angular.toJson({functionName:functionName, action:'return with error', templateId:templateId, error:error.data, status:error.status}));
            analyticsFactory.eventTrack(analyticsFactory.actions.createPDF, analyticsFactory.categories.composer, analyticsFactory.labels.failure, null);
            defer.reject(error.status);
        });

        return defer.promise;
    }

    function getAllTemplates(){
        let functionName = 'templatesService.getAllTemplates';
        $log.log(angular.toJson({functionName:functionName, action:'function called'}));

        var templatesDefer = $q.defer();

        var url = composerBaseUrl;

        $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
        then(function (templateCollection) {
            addDisplayStatusToAllTemplates(templateCollection.data.compositionTemplates);

            //$log.log(angular.toJson({functionName:functionName, action:'function data return', templateCollection:templateCollection}));

            templatesDefer.resolve(templateCollection.data.compositionTemplates);

        },function(error) {
            $log.error(angular.toJson({functionName:functionName, action:'function return error', error:error.data}));
            templatesdefer.reject(error.status);
        });


        return templatesDefer.promise;
    }

    function getTemplatesByPage(page, pageSize, filter, tag, isInitializing){
      let functionName = 'templatesService.getAllTemplates';
      $log.log(angular.toJson({functionName:functionName, action:'function called'}));

      let templatesDefer = $q.defer();
      let url = composerBaseUrl + '/page';

      $http({
        method: 'GET',
        url: url,
        params: {
          'page': page,
          'page-size': pageSize,
          'search-filter': filter,
          'tag': tag,
          'isInitializing': isInitializing
        },
        headers: {'Accept':'application/json'}}).
      then(function (templateCollection) {
        addDisplayStatusToAllTemplates(templateCollection.data.compositionTemplates);

        $log.log(angular.toJson({functionName:functionName, action:'function data return', templateCollection:templateCollection}));

        templatesDefer.resolve(templateCollection.data);

      },function(error) {
        $log.error(angular.toJson({functionName:functionName, action:'function return error', error:error.data}));
        templatesdefer.reject(error.status);
      });
      return templatesDefer.promise;
    }

    function updateTemplate(template){
        let functionName = 'templatesService.updateTemplate';
        $log.log(angular.toJson({functionName:functionName, action:'function called', template:template}));


        var defer = $q.defer();

        var url = composerBaseUrl + "/" + template.templateId;
        $http({method: 'PUT', url: url, data:template,  headers: {'Accept':'application/json','Content-Type':'application/json'}}).
            then(function (updatedTemplate) {

                $log.log(angular.toJson({functionName:functionName, action:'function data return', updatedTemplate:updatedTemplate}));

                defer.resolve(updatedTemplate.data);

            },function(error) {
                $log.error(angular.toJson({functionName:functionName, action:'function return error', template:template, error:error.data}));
                defer.reject(error.status);
            }
        );


        return defer.promise;
    }

    function updateJobProperties(templateId, jobProperties){
      let functionName = 'templatesService.updateJobProperties';

      let url = composerBaseUrl + "/" + templateId + "/update-job-properties";
      $http({method: 'POST', url: url, data: jobProperties, headers: {'Content-Type':'application/json'}})
        .then(function () {
        $log.log(angular.toJson({functionName:functionName}));
      },function (error) {
          $log.error(angular.toJson({functionName:functionName, action:'function return error', error:error.data}));
        }
      );
    }

    function updatePredefinedTemplates(){
      let functionName = 'templatesService.updatePredefinedTemplates';

      let url = composerBaseUrl + "/predefined-templates";
      $http({method: 'POST', url: url})
        .then(function () {
        $log.log(angular.toJson({functionName:functionName}));
      },function (error) {
          $log.error(angular.toJson({functionName:functionName, action:'function return error', error:error.data}));
        }
      );
    }

    function updateTags(templateId, tagsString){
        let functionName = 'templatesService.updateTags';
        $log.log(angular.toJson({functionName:functionName, action:'function called', templateId:templateId}));

        var defer = $q.defer();
        var url = composerBaseUrl + "/" + templateId + "/tags";
        let data = {
            tags:tagsString
        };

        if(isNaN(templateId)){
          defer.reject({
            smsError: {
              statusCode: 400,
              subCode: -1,
              message: 'Template id is not valid'
            }
          });
        }else {
          $http({
            method: 'PUT',
            url: url,
            data: data,
            headers: {'Accept': 'application/json', 'Content-Type': 'application/json'}
          }).then(function (tags) {
            $log.log(angular.toJson({
              functionName: functionName,
              action: 'function data return',
              templateId: templateId,
              tags: tags
            }));
            defer.resolve(tags.data.tags);
          }, function (error) {
            $log.error(angular.toJson({
              functionName: functionName,
              action: 'function return error',
              templateId: templateId,
              error: error.data
            }));
            defer.reject(error.status);
          });
        }
        return defer.promise;
    }

    function addDisplayStatusToAllTemplates(templates){
        for(let iTemplate=0; iTemplate < templates.length;iTemplate++) {
            addDisplayStatusToTemplate(templates[iTemplate]);
        }
    }

    function addDisplayStatusToTemplate(template){

        if(template.warnings !== undefined && template.warnings != null && template.warnings.length > 0 && template.templateCreationStatus === 'Ready'){
            template.templateCreationStatus = "Warning";
        }

        template.statusDisplayText = templateStatus2DisplayStatus(template.templateCreationStatus);


        if(template.templateCreationStatus === 'Error'){
            template.engineError = additionalErrorsTranslatorFactory.getAdditionalErrorMessage(template.additionalError, template.engineError, 'hpdUpload');
        }

        //template.thumbnailUrl = templateStatus2ThumbnailImage(template);
    }

    /*function templateStatus2ThumbnailImage(template){
        if(template.templateCreationStatus === "Error"){
            return errorImage;
        }else if(template.templateCreationStatus  === "Ready"){
            return template.thumbnailUrl;
        }else if(template.templateCreationStatus  === "Uploaded"){
            return processingImage;
        }else if(template.templateCreationStatus  === "EmptyEntryCreated"){
            return uploadingImage;
        }
        else {
            return errorImage;
        }
    }*/

    function templateStatus2DisplayStatus(status){
        if(status === "Error"){
            return 'imposer.composer-main.Composer_Status_Error';
        }else if(status  === "Ready"){
            return 'imposer.composer-main.Composer_Status_Ready';
        }else if(status  === "Uploaded"){
            return 'imposer.composer-main.Composer_Status_Processing';
        }else if(status  === "EmptyEntryCreated"){
            return 'imposer.composer-main.Composer_Status_Uploading';
        }else if(status  === "Warning"){
            return 'imposer.composer-main.Composer_Status_Warning';
        }
        else {
            return 'imposer.composer-main.Composer_Status_Error';
        }
    }


    //todo: note - at the moment this method assume only one cell request. need to make it more generic for n cell requests at the same time.
    function fetchCacheWithEmbeddedDataRequest(templateId, headers, cells, assetsLibsStorageIds, fullImageSize = false){
        let functionName = 'templatesService.fetchCacheWithEmbededDataRequest';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called', cells:cells, templateId:templateId, headers:headers}));

        let defer = $q.defer();

        pusherTaskMessageDispatcherObj.registerProcessingPusherEventIfNotRegistered(pusherEventsForTasks).then(
            function(success){
                let url = composerBaseUrl + '/' + templateId + '/' + "thumbnails";

                let availableSpaceForImage ={};
                if(fullImageSize === true){
                    availableSpaceForImage.deviceScreenHeight = null;
                    availableSpaceForImage.deviceScreenWidth = null;
                }else{
                    availableSpaceForImage = imageLoadProgressService.getAvailableSpaceForImage();
                }


                let clientTimestampInMilliseconds = (new Date()).getTime() - (new Date()).getTimezoneOffset()*60*1000;

                // convert cells to Records and Pages to 1 based
                let cellsOneBased = [];
                for(let iCell = 0; iCell < cells.length; iCell++){
                    // note: at the following we are asking for icell+1 and not for cells[iCell].page + 1.
                      // the reason is that we are creating here a DB per request, this different record numbers.
                      cellsOneBased.push({
                        record:iCell + 1,
                        page:cells[iCell].page + 1,
                        offset:cells[iCell].record + 1,
                        dataValues: cells[iCell].recordData,
                        deviceScreenHeight:availableSpaceForImage.deviceScreenHeight,
                        deviceScreenWidth:availableSpaceForImage.deviceScreenWidth,
                        clientTimestampInMilliseconds:clientTimestampInMilliseconds
                    });
                }

                let thumbnailRequest = {
                    pageRequests: cellsOneBased,
                    dataHeaders:headers,
                    assetsLibsStorageIds: assetsLibsStorageIds
                };

                $http({method: 'POST',data:thumbnailRequest, url: url, headers: {'Accept':'application/json','Content-Type':'application/json'}}).
                    then(function(thumbnailRequestProcess){
                        $log.log(angular.toJson({functionName:functionName, action:'function return with success', thumbnailRequestProcess:thumbnailRequestProcess}));

                        pusherTaskMessageDispatcherObj.registerTaskHandlerMethod(
                            thumbnailRequestProcess.data.processId,
                            function(cellImageUrlsResult){
                                if(cellImageUrlsResult.status === 'Success'){

                                    $log.log(angular.toJson({functionName:functionName, action:'checkProcessStatus completed successfully', cellImageUrlsResult:cellImageUrlsResult}));
                                    for(let iCell=0; iCell < cellImageUrlsResult.cellWithImageStorageId.length; iCell++){
                                        // Note - the returned record numbers relate to the ad-hoc db of this request and not to the overall DB we are handling
                                        // therefore - correct the records to be as they were when request is made - per request index.
                                        cellImageUrlsResult.cellWithImageStorageId[iCell].cell.record = cells[iCell].record;
                                        cellImageUrlsResult.cellWithImageStorageId[iCell].cell.page = cells[iCell].page;
                                    }

                                    defer.resolve(cellImageUrlsResult.cellWithImageStorageId);
                                }else {
                                    $log.error(angular.toJson({functionName:functionName, action:'checkProcessStatus process ended with error', cellImageUrlsResult:cellImageUrlsResult}));



                                    let engineError = null;

                                    if(cellImageUrlsResult.engineErrorMessage){
                                        engineError={
                                            smsError:{
                                                statusCode:500,
                                                subCode:-1,
                                                message:cellImageUrlsResult.engineErrorMessage
                                            }
                                        };
                                    }else{
                                        engineError= {
                                            smsError: {
                                                message: "Unknown",
                                                statusCode: 500
                                            }
                                        };
                                    }
                                    cellImageUrlsResult.engineError = engineError;

                                    defer.reject(cellImageUrlsResult);

                                }
                            }
                        );

                    },function(error) {
                        $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                        defer.reject(error.status);
                    });
            },
            function(status){
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            }
        );
        return defer.promise;
    }

    function jobPropertiesRequest(templateId){
        let functionName = 'templatesService.jobPropertiesRequest';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called', templateId:templateId}));

        let defer = $q.defer();

        let timeoutPromise = $timeout(function() {
          defer.reject({status: 408});
        }, 300000); //Timeout after 5 minutes

        pusherTaskMessageDispatcherObj.registerProcessingPusherEventIfNotRegistered(pusherEventsForTasks).then(
            function(success){
                let url = composerBaseUrl + '/' + templateId + '/' + "job-properties";
                let clientTimestampInMilliseconds = (new Date()).getTime() - (new Date()).getTimezoneOffset()*60*1000;

                $http({method: 'POST', data:clientTimestampInMilliseconds, url: url, headers: {'Accept':'application/json','Content-Type':'application/json'}}).
                    then(function(jobPropertiesRequestProcess){
                        if(jobPropertiesRequestProcess.status === 204){
                          defer.resolve({
                            jobProperties: {spreadCount: 1, recordsInImposition: 1, sheetsInImposition: 1},
                            statusResult: {status: "Success"}
                          });
                        }else{
                            $log.log(angular.toJson({functionName:functionName, action:'function return with success', jobPropertiesRequestProcess:jobPropertiesRequestProcess}));
                            console.log(jobPropertiesRequestProcess.data.processId);
                            pusherTaskMessageDispatcherObj.registerTaskHandlerMethod(
                                jobPropertiesRequestProcess.data.processId,
                                function(response){
                                    $timeout.cancel(timeoutPromise);
                                    if(response !== null){
                                        defer.resolve(response);
                                    }else {
                                        $log.error(angular.toJson({functionName:functionName, action:'checkProcessStatus process ended with error', response:response}));
                                        defer.reject(response);
                                    }
                                }
                            );
                        }
                    },function(error) {
                        $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                        defer.reject(error);
                    });
            },
            function(status){
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            }
        );
        return defer.promise;
    }

    function checkProcessStatus(templateId, processId){
        let functionName = 'templatesService.checkProcessStatus';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called', templateId:templateId, processId:processId}));

        let defer = $q.defer();

        let url = composerBaseUrl + '/' + templateId + '/' + "thumbnails" + '/' + processId;

        $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
            then(function(cellImageUrlsResult) {
                $log.info(angular.toJson({functionName: functionName, action: 'successfully return', cellImageUrlsResult:cellImageUrlsResult}));
                defer.resolve(cellImageUrlsResult.data);
            },function(error) {
                    $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                    defer.reject(error.status);
            });


        return defer.promise;
    }

    function createEmptyFileEntryHelper(file) {
        let functionName = 'templatesService.uploadFile';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called', filename: file.name}));

        let defer = $q.defer();

        createEmptyFileEntry(file).then(
            function (storageAssetInfo) {
                $log.info(angular.toJson({
                    functionName: functionName,
                    action: 'createEmptyFileEntry completed successfully',
                    storageAssetInfo: storageAssetInfo
                }));
                defer.resolve(storageAssetInfo);
            },
            function (error) {
                $log.error(angular.toJson({
                    functionName: functionName,
                    action: 'createEmptyFileEntry return with error',
                    error: error.data
                }));
                defer.reject(error.data);
            }
        );

        return defer.promise;
    }

    function uploadFile(file, uploadProgressCallback, storageAssetInfo) {
        let functionName = 'templatesService.uploadFile';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called', filename: file.name}));

        let defer = $q.defer();

        $log.info(angular.toJson({
            functionName: functionName,
            action: 'createEmptyFileEntry completed successfully',
            storageAssetInfo: storageAssetInfo
        }));

        uploadFileToStorageService(file.name, file, storageAssetInfo.assetId, null, uploadProgressCallback).then(
            function (storageAssetMetadata) {
                $log.info(angular.toJson({
                    functionName: functionName,
                    action: 'uploadTemplateToEntry completed successfully',
                    storageAssetMetadata: storageAssetMetadata
                }));
                defer.resolve(storageAssetInfo.assetId);

            }, function (error) {
                $log.error(angular.toJson({
                    functionName: functionName,
                    action: 'uploadFileToStorageService return with error',
                    error: error
                }));
                defer.reject(error);
            }
        );


        return defer.promise;
    }
    // function uploadFile(file, uploadProgressCallback){
    //     let functionName = 'templatesService.uploadFile';
    //     $log.info(angular.toJson({functionName: functionName, action: 'functionName called', filename:file.name}));
    //
    //     let defer = $q.defer();
    //
    //     createEmptyFileEntry(file).then(
    //         function(storageAssetInfo){
    //             $log.info(angular.toJson({functionName: functionName, action: 'createEmptyFileEntry completed successfully', storageAssetInfo:storageAssetInfo}));
    //
    //             uploadFileToStorageService(file.name, file, storageAssetInfo.assetId, null, uploadProgressCallback).then(
    //                 function(storageAssetMetadata){
    //                     $log.info(angular.toJson({functionName: functionName, action: 'uploadTemplateToEntry completed successfully', storageAssetMetadata:storageAssetMetadata}));
    //                     defer.resolve(storageAssetInfo.assetId);
    //
    //                 },function(error){
    //                     $log.error(angular.toJson({functionName: functionName, action: 'uploadFileToStorageService return with error', error:error}));
    //                     defer.reject(error);
    //                 }
    //             );
    //         },
    //         function(error){
    //             $log.error(angular.toJson({functionName: functionName, action: 'createEmptyFileEntry return with error', error:error.data}));
    //             defer.reject(error.data);
    //         }
    //     );
    //
    //     return defer.promise;
    // }

    function createEmptyFileEntry(file){
        let functionName = 'templatesService.createEmptyFileEntry';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called',filename:file.name}));
        let defer = $q.defer();

        let url = composerDataUrl + "/file";

        $http({method: 'POST', url: url, headers: {'Accept':'application/json'}}).
            then(function(storageAssetInfo){
                $log.log(angular.toJson({functionName:functionName, action:'function return with success', storageAssetInfo:storageAssetInfo}));
                defer.resolve(storageAssetInfo.data);
            },function(error) {
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            });

        return defer.promise;
    }

    function uploadTemplate(file, templateEntryCreationRequest, templateList, uploadProgressCallback, processingCompleteCallback, uploadController) {
        let functionName = 'templatesService.uploadTemplate';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called'}));

        let defer = $q.defer();

        let timer = {};

        //let startTime = performance.now();
        let isAnalyticsEventIssued = false;

        createEmptyTemplateEntry(templateEntryCreationRequest).then(
            function(templateEntry){
                $log.info(angular.toJson({functionName: functionName, action: 'createEmptyTemplateEntry completed successfully', templateEntry:templateEntry}));

                let uploadIdentity = {
                    compositionTemplate:"Composition Template",
                    compositionTemplateId: templateEntry.templateId
                };

                if(uploadProgressCallback){
                    uploadProgressCallback(null, templateEntry.templateId);
                }

                if(uploadController && uploadController.cancel === true){
                    deleteTemplate(templateEntry.templateId);
                    return;
                }

                let percentageReportInterval = 1;
                uploadFileToStorageService(uploadIdentity, file, templateEntry.templateStorageId, percentageReportInterval, uploadProgressCallback, uploadController).then(
                    function(StorageAssetInfo){
                        $log.info(angular.toJson({functionName: functionName, action: 'uploadTemplateToEntry completed successfully', StorageAssetInfo:StorageAssetInfo}));

                        if(uploadController && uploadController.cancel === true){
                            return;
                        }

                        reportTemplateUploadCompletion(templateEntry.templateId).then(
                            function(compositionTemplate){
                                $log.info(angular.toJson({functionName: functionName, action: 'uploadTemplateToEntry completed successfully', compositionTemplate:compositionTemplate}));

                                defer.resolve(compositionTemplate); // todo: check this - I think it is a mistake...
                            },function(error){

                                $log.error(angular.toJson({functionName: functionName, action: 'reportTemplateUploadCompletion return with error', error:error}));
                                defer.resolve(error);
                            });
                    },function(error){

                        $log.error(angular.toJson({functionName: functionName, action: 'uploadTemplateToEntry return with error', error:error.data}));
                        defer.resolve(error.data);
                    });
            },function(error){
                $log.error(angular.toJson({functionName: functionName, action: 'createEmptyTemplateEntry return with error', error:error.data}));
                defer.reject(error.data);
            });

        return defer.promise;
    }

    function createEmptyTemplateEntry(templateEntryCreationRequest){
        let functionName = 'templatesService.createEmptyTemplateEntry';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called', templateEntryCreationRequest:templateEntryCreationRequest}));

        var defer = $q.defer();

        let url = composerBaseUrl;

        $http({method: 'POST', url: url, data: templateEntryCreationRequest, headers: {'Accept':'application/json','Content-Type':'application/json'}}).
            then(function(templateEntry){
                $log.log(angular.toJson({functionName:functionName, action:'function return with success', templateEntry:templateEntry}));
                defer.resolve(templateEntry.data);
            },function(error) {
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            });

        return defer.promise;
    }

    function reportTemplateUploadCompletion(templateId){
        let functionName = 'templatesService.reportTemplateUploadCompletion';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called', templateId:templateId}));
        let defer = $q.defer();
        let url = composerBaseUrl + "/" + templateId;
        let clientTimestampInMilliseconds = (new Date()).getTime() - (new Date()).getTimezoneOffset()*60*1000;
        let uploadCompletionStatus ={
            success:true,
            clientTimestampInMilliseconds:clientTimestampInMilliseconds
        };

        $http({method: 'POST', url: url, data: uploadCompletionStatus, headers: {'Accept':'application/json'}}).
            then(function(template){
                $log.log(angular.toJson({functionName:functionName, action:'function return with success', template:template.data}));
                defer.resolve(template.data);
            },function(error) {
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            });

        return defer.promise;
    }

    function checkPostUploadProcessing(templateId){
        let functionName = 'templatesService.checkPostUploadProcessing';
        $log.info(angular.toJson({functionName: functionName, action: 'functionName called', templateId:templateId}));
        let defer = $q.defer();

        let url = composerBaseUrl + "/" + templateId + "/preparation-status";


        $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
            then(function(postUploadTemplate){
                $log.log(angular.toJson({functionName:functionName, action:'function return with success', postUploadTemplate:postUploadTemplate.data}));
                defer.resolve(postUploadTemplate.data);
            },function(error) {
                $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
                defer.reject(error.status);
            });

        return defer.promise;
    }



    /********************************* File Upload ****************************************************************************************************************/

    function uploadFileToStorageService(identification, file, storageServiceId, percentageReportInterval = null, uploadProgressCallback = null, uploadController = null){

        var defer = $q.defer();
        var progressReportInterval = percentageReportInterval || 10;

        var storageClientLibrary = new com.hp.sms.storage_service.StorageClientLibrary();

        var parallelUploadCallback = new ParallelUploadCallback(identification, defer, uploadProgressCallback, uploadController);

        let fileExtension = file.name.split('.').pop();
        const renamedFile = new File([file], uuidv4() + "." + fileExtension, {type: file.type});
        var parallelUploadToExistingEntry = new storageClientLibrary.ParallelUploadToExistingEntryDirectly(renamedFile, storageServiceId, progressReportInterval,
            parallelUploadCallback.theCallback,'application/octet-stream');

        parallelUploadCallback.setParallelUploadToExistingEntry(parallelUploadToExistingEntry);

        parallelUploadToExistingEntry.uploadFile();

        return defer.promise;
    }


    function ParallelUploadCallback (identification, templatesDefer, uploadProgressCallback, uploadController = null){
        let functionName='templatesService.ParallelUploadCallback';
        var parallelUploadToExistingEntry = null;


        this.setParallelUploadToExistingEntry = function(_parallelUploadToExistingEntry){
            parallelUploadToExistingEntry = _parallelUploadToExistingEntry;
        };

          // the callback function.
        // stage - the stage of the upload - WaitingForFileUpload_State, UploadInitializing_State, Uploading_State, WaitingUploadToComplete_State, UploadCompleted_State, UploadAborted_State, Error_State
        // status - "Okay" or "Error"
        // data - additional data, different per stage - the below method show which data is available per stage status report
        // errorInfo - the HTTP error information in case of error, including message from server in case server returned the error
        this.theCallback = function(stage, status, data, errorInfo) {

            var resultString;

            // The following is sent when Upload Initializing is done - with success or error.
            // Data is not expected at this stage.
            if(stage === com.hp.sms.storage_service.UploadInitializing_State){

                // ***************** Upload Initialization *****************
                if(status === "Okay"){
                    $log.info(angular.toJson({functionName:functionName, action:'Upload Initialization Success', identification:identification}));
                }else{
                    $log.info(angular.toJson({functionName:functionName, action:'Failed to Initialization upload ',errorInfo:errorInfo,errorData:data, identification:identification}));
                    templatesDefer.reject(errorInfo);
                }
            }

            // The following is sent when Upload is in progress - for progress information or error
            // In case the upload is in progress, the callback contain the upload percentage.
            if(stage === com.hp.sms.storage_service.WaitingUploadToComplete_State || stage === com.hp.sms.storage_service.Uploading_State){
                // ***************** Upload Progress Report *****************
                if(status === "Okay"){
                    $log.info(angular.toJson({functionName:functionName, action:'Upload in progress', data:data, identification:identification}));
                    if(uploadProgressCallback){
                        uploadProgressCallback(data.uploadReportPercentage, data.assetId);
                    }

                    if(uploadController && uploadController.cancel === true){
                        if(parallelUploadToExistingEntry){
                            parallelUploadToExistingEntry.abortUpload();
                        }
                    }

                }else{
                    $log.info(angular.toJson({functionName:functionName, action:'Failed to Upload', errorInfo:errorInfo,errorData:data, identification:identification}));
                    templatesDefer.reject(errorInfo);
                }
            }

            // The following is sent when upload completed successfully or with error.
            // Data is not expected at this stage.
            if(stage === com.hp.sms.storage_service.UploadCompleted_State){
                // ***************** Upload Completed *****************
                if(status === "Okay"){
                    $log.info(angular.toJson({action:'Upload progress', functionName:functionName, data:data, identification:identification}));
                    //approveUploadCompletion(templateId, templatesDefer)
                    templatesDefer.resolve(data);
                }else{
                    $log.info(angular.toJson({action:'Failed to Complete Upload', functionName:functionName,errorInfo:errorInfo,errorData:data, identification:identification}));
                    templatesDefer.reject(errorInfo);
                }
            }
        };
    }

    /********************************* End of File Upload ************************************************************************************************************/

    function approveUploadCompletion (templateId){

        let functionName='templatesService.approveUploadCompletion';

        var templatesDefer = $q.defer();
        var url = composerBaseUrl + '/imposition-templates/' + templateId;

        var uploadCompletionStatus ={
            success: true
        };

        $http({method: 'POST', url: url, data: uploadCompletionStatus, headers: {'Content-Type': 'application/json',
            'Accept': 'application/json'}}).
            then(function (data) {
                $log.info(angular.toJson({action:'function return', functionName:functionName,data:data.data}));
                templatesDefer.resolve(data.data);
            },function(error) {
                $log.info(angular.toJson({action:'function return error', functionName:functionName, error:error.data}));
                templatesDefer.reject(error.data);
            });

        return templatesDefer.promise;
    }

    function getTemplate(templateId){
        let functionName='templatesService.getTemplate';
        $log.info(angular.toJson({action:'function called', functionName:functionName}));

        var assetsDeferred = $q.defer();
        var url = composerBaseUrl + '/' + templateId;

        $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
            then(function (template) {
                addDisplayStatusToTemplate(template.data);
                assetsDeferred.resolve(template.data);
            },function(error) {
                $log.error(angular.toJson({action:'$http return with error', functionName:functionName, error:error.data}));
                assetsDeferred.reject(error.status);
            });

        $log.info(angular.toJson({action:'function return', functionName:functionName}));
        return assetsDeferred.promise;
    }

    function deleteTemplate(templateId){
        let functionName='templatesService.deleteTemplate';
        $log.info(angular.toJson({action:'function called', functionName:functionName,templateId:templateId}));

        var deferred = $q.defer();

        var url = composerBaseUrl + "/" + templateId;

        $http({method: 'DELETE', url: url}).
            then(function (data) {
                $log.info(angular.toJson({action:'function return', functionName:functionName,data:data.data}));
                deferred.resolve(data.data);
            },function(error) {
                $log.error(angular.toJson({action:'function return error', functionName:functionName}));
                deferred.reject(error.status);
            });
        return deferred.promise;
    }

    function deleteMultipleTemplates(templateIds){
        let functionName='templatesService.deleteTemplate';
        $log.info(angular.toJson({action:'function called', functionName:functionName,templateIds:templateIds}));

        var deferred = $q.defer();
        var url = composerBaseUrl + "/multi";

        let templatesToDelete ={
          templateIds: templateIds
        };

        $http({method: 'DELETE', data: templatesToDelete, url: url, headers: {'Content-Type':'application/json'}}).
            then(function (data) {
                $log.info(angular.toJson({action:'function return', functionName:functionName,data:data.data}));
                deferred.resolve(data.data);
            },function(error) {
                $log.error(angular.toJson({action:'function return error', functionName:functionName}));
                deferred.reject(error.status);
            });
        return deferred.promise;
    }

    function getTemplateDb(storageId){
        let functionName='templatesService.getTemplateDb';
        $log.info(angular.toJson({action:'function called', functionName:functionName, storageId:storageId}));
        var assetsDeferred = $q.defer();

        let url = composerDataUrl + '/' + storageId + '/presigned-url';
        $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
        then(function(presignedUrl) {
            var oReq = new XMLHttpRequest();
            let url = presignedUrl.data.presignedUrl;
            oReq.open("GET", url, true);
            oReq.responseType = "text";
            oReq.onload = function(oEvent) {
                //this.response
                assetsDeferred.resolve(this.response);
            };

            oReq.send();
        },function (error) {
            $log.warn(angular.toJson({action:'function return error', functionName:functionName}));
            assetsDeferred.reject(error.data);
        });

        $log.info(angular.toJson({action:'function return', functionName:functionName}));
        return assetsDeferred.promise;
    }

    function getTemplateDbFromURL(url){
        let functionName='templatesService.getTemplateDbFromURL';
        $log.info(angular.toJson({action:'function called', functionName:functionName, url:url}));
        var assetsDeferred = $q.defer();

        var oReq = new XMLHttpRequest();

        oReq.open("GET", url, true);
        oReq.responseType = "text";
        oReq.onload = function(oEvent) {
            //this.response
            assetsDeferred.resolve(this.response);
        };

        oReq.send();

        $log.info(angular.toJson({action:'function return', functionName:functionName}));
        return assetsDeferred.promise;
    }

    function getUserPreferences(){
        let functionName='templatesService.getUserPreferences';
        $log.info(angular.toJson({action:'function called', functionName:functionName}));

        var deferred = $q.defer();

        var url = "/api/portal/v1/preferences";

        $http({method: 'GET', url: url,headers: {'Accept':'application/json'}}).then(function (data) {
            deferred.resolve(data.data);//{general:{unitSystem:"Metric"}});
        },function (error) {
            $log.warn(angular.toJson({action:'function return error', functionName:functionName}));
            deferred.reject(error.data);
        });

        return deferred.promise;
    }



    function getUserInfo(){
        let functionName='templatesService.getUserInfo';
        $log.info(angular.toJson({action:'function called', functionName:functionName}));
        let deferred = $q.defer();

        let url = "/api/composer-service/v1/user-info/users";

        $http({method: 'GET', url: url,headers: {'Accept':'application/json'}}).then(function (data) {
            if(data.data === undefined || data.data === null){
                deferred.reject();
            }else{
                deferred.resolve(data.data.displayName);
            }

        },function (error) {
            $log.warn(angular.toJson({action:'function return error', functionName:functionName}));
            deferred.reject(error.data);
        });

        return deferred.promise;
    }

  function viewErrorDetails($event, template){
    if($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $event.forceTemplateSelection = true;
    }

    let errorContent=[];

    let errorMessage = template.engineError;

    if(template.engineError === 'FailedToDownloadHPD'){
      errorMessage = $translate.instant('imposer.composer-main.failed_to_download_hpd', [template.templateName]);
    }

    errorContent.push({
      title:$translate.instant('imposer.composer-main.Composer_Error_Details')  + ':',
      body:errorMessage,
      rowType:'message',
      additionalBody:template.warnings,
      shouldTranslate:false
    });

    $mdDialog.show({
      parent: angular.element(document.body),
      targetEvent: $event,
      clickOutsideToClose: false,
      escapeToClose: true,
      template: require('@printos/imposer-ui/src/components/templates/error-dialog-more-info/errorDialogMoreInfo.html'),
      controller: 'ErrorDialogMoreInfoController',
      bindToController: true,
      controllerAs: 'vm',
      locals:{dialogTitle: template.templateName + ".HPD", errorContent:errorContent}
    })
      .then(function () {
        // $log.info(angular.toJson({action:'dialog closed successfully', functionName:functionName}));
      })
      .catch(function () {
        // $log.info(angular.toJson({action:'dialog failure', functionName:functionName}));

      })
      .finally(function () {
        // isAlreadyOpen = false;
      });
  }

  function getConfigurations(){
    let functionName = 'templatesService.getConfigurations';
    $log.info(angular.toJson({functionName: functionName, action: 'functionName called'}));

    let defer = $q.defer();

    let url = portalUrl + '/client/config';

    return $http({method: 'GET', url: url, headers: {'Accept':'application/json'}}).
    then(function(response) {
      return response.data;
    },function (error) {
      $log.error(angular.toJson({functionName:functionName, action:'function return error',error:error.data, status:error.status}));
      defer.reject(error.status);
    });
  }
}
